module.exports = __webpack_public_path__ + "img/2020TopTen.5beb4594.jpg";